import { alertRequest, body, request } from "services/request";

const resource = "api/documentNumberSettings";

export interface DocumentNumberSettingsModel {
    infoBasePrefix?: string | null;
    organizationPrefix?: string | null;
    nextNumber?: number | null;
    nextNumberPreview?: string | null;
}

export type DocumentNumberSettingsResponse = DocumentNumberSettingsModel | false | null | undefined;

export interface ApplyDocumentNumberSettingsModel {
    infoBasePrefix: string;
    organizationPrefix: string;
    nextNumber: number;
}

export const getDocumentNumberSettings = (): Promise<DocumentNumberSettingsResponse> =>
    request(`${resource}/get`, { method: "GET" });

export const applyDocumentNumberSettings = (params: ApplyDocumentNumberSettingsModel) =>
    alertRequest(`${resource}/apply`, body(params));
